/**
 * Injects global Organization and WebSite JSON-LD structured data into every
 * page via useHead. These schemas help search engines and AI crawlers
 * understand the site entity and enable sitelinks search.
 */
export default defineNuxtPlugin(() => {
    const organizationLd = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Unified.to',
        url: 'https://unified.to',
        logo: 'https://unified.to/logos/Unified_Black.png',
        description:
            'Unified.to is a real-time unified API and MCP platform that lets developers integrate with 380+ SaaS applications through a single API.',
        foundingDate: '2023',
        founders: [
            { '@type': 'Person', name: 'Roy Pereira', jobTitle: 'CEO & co-founder' },
            { '@type': 'Person', name: 'Alexey Adamsky', jobTitle: 'CTO & co-founder' },
        ],
        sameAs: [
            'https://www.linkedin.com/company/unifiedto/',
            'https://twitter.com/unified_api',
            'https://github.com/unified-to',
        ],
        contactPoint: {
            '@type': 'ContactPoint',
            url: 'https://unified.to/contact',
            contactType: 'sales',
        },
    };

    const websiteLd = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Unified.to',
        url: 'https://unified.to',
        potentialAction: {
            '@type': 'SearchAction',
            target: 'https://unified.to/blog?q={search_term_string}',
            'query-input': 'required name=search_term_string',
        },
    };

    useHead({
        script: [
            {
                type: 'application/ld+json',
                key: 'global-organization-ld',
                textContent: JSON.stringify(organizationLd),
            },
            {
                type: 'application/ld+json',
                key: 'global-website-ld',
                textContent: JSON.stringify(websiteLd),
            },
        ],
    });
});
